import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'camelCaseSeparator' })
export class CamelCaseSeperatorPipe implements PipeTransform {
  transform(value: string): string {
    return value
      .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space before capital letters
      .replace(/^./, (str) => str.toUpperCase()); // Capitalize the first letter
  }
}
